module.exports = __webpack_public_path__ + "images/notifications-onboarding/Filter_Illos.0ff7c7afe299ca73beed.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/notifications-onboarding/Filter_Illos.svg
// module id = dySb
// module chunks = 12